import axios from 'axios';

const AIService = {
    getCompletion: async (message, callback = null, errorCallback = null) => {
        await axios.post('/api/gm/', { role: 'user', text: message }).then((response) => {
            if(callback) {
                callback(response.data);
            }
        })
        .catch((error) => {
            if(errorCallback) {
                errorCallback(error);
            }
        })
    },

    getCompletionWithContext: async(message, context, callback = null, errorCallback = null) => {
        console.info(message, context)
        message += "\ncontext:\n" + context.map(item => item.content + "\n");
        let data = { role: 'user', text: message }
        await axios.post('/api/gm/', data).then((response) => {
            if(callback) {
                callback(response.data);
            }
        })
        .catch((error) => {
            if(errorCallback) {
                errorCallback(error);
            }
        })
    },

    appendContext: (entry, role, content) => {
        entry.notes.push({ role: role, text: content });
    }
}

export default AIService;